<template>
  <div class="contentBox">
    <navBox :id="navId" ref="navBox"></navBox>

    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>用户ID:</p>
          <input type="text" placeholder="" v-model="obj.student_id	">
        </div>
        <div class="search-item">
          <p>手机号:</p>
          <input type="text" placeholder="" v-model="obj.mobile">
        </div>
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>学员管理</p>
          <div class="btnBox">
            <button class="btn btn-updown" @click="updown" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('2-1')>-1">下载模板</button>
            <!-- <button class="btn btn-import" v-if="obj.cert_id" @click="studentSub">导入学员</button> -->
            <el-upload
              v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('2-1')>-1"
              class="upload-demo btn btn-import"
              :action="url+'/org/student/importStudent'"
              :headers="{'userToken':token}"
              :on-success="handleSuccess"
              accept=".xls, .xlsx"
              :show-file-list="false"
              :data="{type:'2-1'}"
            >
              <el-button size="small" type="primary">导入学员</el-button>
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>
            <button class="btn btn-add" @click="addStudent" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('2-1')>-1">添加学员</button>
          </div>
        </div>
        <div class="organiza-list" :class="obj.cert_id?'organiza-list1':''">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList" v-if="obj.cert_id">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="(index+1)">{{(index+1)}}</p>
              <p :title="item.student_id">{{item.student_id}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <p :title="item.sex==1?'男':'女'">{{item.sex==1?'男':'女'}}</p>
              <p :title="item.age">{{item.age}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
            </div>
          </div>
          <div class="dataList" v-else>
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="(index+1)">{{(index+1)}}</p>
              <p :title="item.student_id">{{item.student_id}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.mobile">{{item.mobile}}</p>
              <p :title="item.sex==1?'男':'女'">{{item.sex==1?'男':'女'}}</p>
              <p :title="item.age">{{item.age}}</p>
              <p :title="item.cert_name">{{item.cert_name}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p style="color:#FF7543" @click="editSub(item)" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('2-2')>-1">编辑</p>
              <p style="color:#FF5156" @click="cancelShow(item)" v-if="userData.level==1 || userData.level==2&&userData.authority.indexOf('2-3')>-1">注销</p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加提示框 -->
    <div class="msgBox tipsBox addTips" v-if="addTip">
      <div class="contv">
        <p class="title">添加学员</p>
        <form>
          <div class="write-txt">
            <p>姓名：</p>
            <input type="text" v-model="addObj.name">
          </div>
          <div class="write-txt">
            <p>手机号：</p>
            <input type="text" v-model="addObj.mobile" @input="numCheck(addObj.mobile,11,'mobile')">
          </div>
          <div class="write-txt">
            <p>性别：</p>
            <select v-model="addObj.sex">
              <option value="">请选择性别</option>
              <option value="1">男</option>
              <option value="2">女</option>
            </select>
          </div>
          <div class="write-txt">
            <p>出生日期：</p>
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="addObj.birth"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-remove" @click="addSub('add')">添加</button>
          <button class="btn btn-close" @click="closeSub('add')">取消</button>
        </div>
      </div>
    </div>

    <!-- 添加提示框1 -->
    <div class="msgBox tipsBox addTips" v-if="addType" >
      <div class="contv">
        <p class="title">{{addType=='add'?'添加学员':'编辑学员'}}</p>
        <form>
          <div class="write-txt">
            <p>姓名：</p>
            <input type="text" v-model="addObj.name">
          </div>
          <div class="write-txt">
            <p>手机号：</p>
            <input type="text" v-model="addObj.mobile" @input="numCheck(addObj.mobile,11,'mobile')">
          </div>
          <div class="write-list" v-if="!obj.cert_id">
            <div class="write-txt">
              <p>证书：</p>
              <el-select v-model="addObj.cert_ids" multiple placeholder="请选择" @change="$forceUpdate()">
                <el-option
                  v-for="item in CertList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- <button class="btn btn-add " @click.prevent="">添加证书</button> -->
          </div>
          <div class="write-txt">
            <p>性别：</p>
            <select v-model="addObj.sex">
              <option value="">请选择性别</option>
              <option value="1">男</option>
              <option value="2">女</option>
            </select>
          </div>
          <div class="write-txt">
            <p>出生日期：</p>
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="addObj.birth"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-remove" @click="addSub('add')">添加</button>
          <button class="btn btn-close" @click="closeSub('add')">取消</button>
        </div>
      </div>
    </div>

    <!-- 删除提示框 -->
    <div class="msgBox removeBox" v-if="removeType">
      <div class="contv">
        <p class="title">提示</p>
        <p class="txt">确认注销此条学员数据么？</p>
        <div class="btnBox">
          <button class="btn btn-remove" @click="removeSub('remove')">确认</button>
          <button class="btn btn-close" @click="closeSub('remove')">取消</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getStudentList,saveStudent,getSelectCertTypeList,getStudentDetail,delStudent,getSelectCertList,importStudent } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      fileUrl:'/static/student_template.xlsx',
      navId:'3',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'用户ID'},
        {id:3,title:'姓名'},
        {id:4,title:'手机号'},
        {id:5,title:'性别'},
        {id:6,title:'年龄'},
        {id:7,title:'注册时间'},
      ],
      dataList:[],
      currentPage1: 2,
      removeType:false,
      topicType:[
        {id:1,title:'单选题'},
        {id:2,title:'多选题'},
        {id:3,title:'判断题'},
      ],
      showType:'list',
      value1: '',
      addType:'',
      addTip:false,
      obj:{
        page:1,
        rows:10,
        type:'1-2-3'
      },
      addObj:{
        mobile:'',
        name:'',
        sex:'',
        birth:'',
      },
      token:"",
      totalPage:0,
      CertList:[],
      certidList:[
        {cert_id:''}
      ],
      removeID:"",
      fileUrl:'/static/student_template.xlsx',
      userData:{
        authority:[],
      },
      url:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  watch: {
    $route() {
      this.watchPage();
    }
  },
  mounted(){
    var that = this;
    this.watchPage();
    getSelectCertList(this.token).then((res)=>{
      var data = res.data;
      if(data.code == 200){
        that.CertList = data.data;
      } else {
        that.$message(data.msg);
      }
    })
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.watchPage();
    },

    handleSuccess(response, file, fileList){
      var that = this;
      if(response.code == 200){
        that.$message('上传成功！');
        that.watchPage();
      } else {
        that.$message(response.msg);
      }
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj={
        page:1,
        rows:10,
        type:'1-2-3'
      };
      this.addObj = {
        mobile:'',
        name:'',
        sex:'',
        birth:'',
      }
      var id = this.$route.query.id;
      if(id){
        this.obj.cert_id = id;
      }
      this.dataList = [];
      this.getList();
      
    },


    watchPage(){
      var that = this;
      var id = this.$route.query.id;
      if(id){
        this.titleList=[
          {id:1,title:'序号'},
          {id:2,title:'用户ID'},
          {id:3,title:'姓名'},
          {id:4,title:'手机号'},
          {id:5,title:'性别'},
          {id:6,title:'年龄'},
          {id:7,title:'注册时间'},
        ];
        this.obj.cert_id = id;
        this.addObj.cert_id = id;
      } else {
        this.titleList=[
          {id:1,title:'序号'},
          {id:2,title:'用户ID'},
          {id:3,title:'姓名'},
          {id:4,title:'手机号'},
          {id:5,title:'性别'},
          {id:6,title:'年龄'},
          {id:7,title:'证书'},
          {id:8,title:'注册时间'},
        ];
        // if(this.obj.cert_id){
          delete this.obj.cert_id;
        // };
        this.addObj.cert_ids=[];
        console.log(this.obj,'==this.obj==')
      };
      this.userData = this.$refs.navBox.userData
      this.token =this.userData.token;
      this.url = this.$refs.navBox.url;
      this.getList();
      
    },

    removeSub(type){
      var that = this;
      if(type == 'tip'){
        this.addTip = false;
      } else if(type == 'add'){
        this.addType = ''
      } else {
        delStudent({id:that.removeID,type:'2-3'},that.token).then((res)=>{
          var data = res.data;
          if(data.code == 200){
            that.$message('注销成功！');
            that.resetSub();
            that.removeType = false;
          } else {
            that.$message(data.msg);
          }
        })
      }
    },

    closeSub(type){
      if(type == 'tip'){
        this.addTip = false;
      } else if(type == 'add'){
        this.addObj = {
          mobile:'',
          name:'',
          sex:'',
          birth:'',
        }
        this.addType = ''
      } else {
        this.removeType = false;
      }
    },

    editSub(e){
      var that = this;
      getStudentDetail({id:e.id,type:'2-2'},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.addObj = data.data;
          that.addObj.id = e.id;
          that.addType = 'edit';
          // that.addObj.cert_ids.forEach(function(item,index){
          //   item = parseInt(item);
          // });
          if(that.addObj.cert_ids.length<=0){
            return false;
          }
          for(var i = 0;i < that.addObj.cert_ids.length;i++){
            that.addObj.cert_ids[i] = parseInt(that.addObj.cert_ids[i])
          };
          console.log(that.addObj)
        } else {
          that.$message(data.msg);
        }
      })
    },

    // 添加学员
    addStudent(){
      var that = this;
      // if(this.obj.cert_id){
      //   this.addTip = true;
      // } else {
        this.addType = 'add';
        
      // }
    },

    // 注销
    cancelShow(e){
      this.removeType = true;
      this.removeID = e.id;
    },

    addCert(){
      var that = this;
      // console.log(that.addObj.cert_ids);
      // that.addObj.cert_ids.push({cert_id:''});
      // this.$forceUpdate();

      // this.certidList.push({cert_id:''});
      console.log(this.value1)
    },

    getList(){
      var that = this;
      getStudentList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
          console.log(that.obj,that.totalPage)
        } else {
          that.$message(data.msg);
        }
      })
    },

    addSub(type){
      var that = this;
      // if(this.obj.cert_id){
        
      // } else {
        if(type == 'add'){
          var regex = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9])\d{8}$/i;
          console.log(that.addObj,'=obj==');
          if(that.addObj.name == ''){
            that.$message('请填写姓名！');
            return false;
          } else if(that.addObj.mobile === '' || !regex.test(that.addObj.mobile)){
            that.$message('请输入正确的手机号码！');
            return false;
          }  else if(that.addObj.sex == ''){
            that.$message('请选择性别！');
            return false;
          } else if(that.addObj.birth == ''){
            that.$message('请选择出生日期！');
            return false;
          };

          if(!that.obj.cert_id){
            if(that.addObj.cert_ids.length == 0){
              that.$message('请选择证书！');
              return false;
            };
          };
          that.addObj.type = '2-1'
          saveStudent(that.addObj,this.token).then((res)=>{
            var data = res.data;
            if(data.code == 200){
              that.$message('添加成功！');
              that.resetSub();
              that.addType = '';
            } else {
              tjat.$message(data.msg);
            }
          })
        }
      // }
    },

    numCheck(e,i,type){
      var that = this;
      var num = e;
      num = num.length;
      if(num > i){
          if(type == 'mobile'){
              e = e.slice(0,11);
              that.addObj.mobile = e;
          } else {
              that.code = JSON.stringify(e).slice(0,4)
          }
      }
    },

    certSub(e,i){
      console.log(e,i)
      var that = this;
      var id = e.target.value;
      this.certidList.forEach(function(item,index){
        if(item.cert_id == parseInt(id)){
          console.log(item.cert_id,parseInt(id))
          item.cert_id = '';
          that.$message('请勿重复选择！');
          return false;
        };
      });
      // that.certidList.push({cert_id:id});
      console.log(this.ll,this.certidList,'==certidList==');
    },

    studentSub(){
      var that = this;
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = that.fileUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
          that.$message('下载异常！')
      }
    },

    updown(){
      var that = this;
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = that.fileUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
      } catch (e) {
          that.$message('下载异常！')
      }
    },
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: 10%;
}

.organiza-list1 .dataList .listItem p,
.organiza-list1 .titleList p{
  width: calc( 100% / 7 );
}

.write-list{
}

.write-list .btn-add{
  color: #4C7EFB;
  font-size: 15px;
  width: 225px;
  margin-top: 20px;
}

.addStudent.tipsBox .contv{
  height: 80%;
}

.addStudent.tipsBox form{
  height: calc( 100% - 140px );
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 20px;
}

.organiza-title .btnBox .btn{
  display: inline-block;
  vertical-align: top;
  text-align: center;
}
.organiza-title .btnBox .btn .el-button--primary{
  background-color: transparent;
  border-color: transparent;
}

.organiza-title .btnBox .btn .el-button--small{
  font-size: 15px;
}
.organiza-title .btnBox .btn .el-upload-list__item-name{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/student/index.vue